export default IconArrowRampRight2 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-ramp-right-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M6 3v8.707" />
  <path d="M16 14l4 -4l-4 -4" />
  <path d="M6 21c0 -6.075 4.925 -11 11 -11h3" />
</svg>`;